import React from 'react';
import Atelier5Container from './Atelier5Container';

const Atelier5 = ({ activeTab }) => {
  return <Atelier5Container activeTab={activeTab} />;
};

export default Atelier5;